import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@/shared/shared.module';
import { DialogBoletoComponent } from './dialog-boleto.component';



@NgModule({
  declarations: [DialogBoletoComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class DialogBoletoModule { }
